define([
	"dojo/_base/declare",
	"csi/state/rootStore",
	"Quality/NewTestRun"
], function(declare,{ routerStore },NewTestRun) {

	return declare(NewTestRun, {
		getFormData: function() {
			// summary: trick csi.form.Widget.getFormNode into using Product as parent, not ProductColor
			var	fd = this.inherited(arguments);
			fd.m_parentNode = this.m_cache.getNode(fd.getParent().__Parent__, true);
			return fd;
		},

		/**
		 * @override
		 * Product is actually higher up because this is from Color Material
		 * Also need to set the color explicitly
		 */
		getTestRunFormParams: function(params) {
		    params = params || {};
		    params.testRunColor = this.getParent().$URL;
		    params.testRunContextNode = routerStore.getBreadcrumbNode("Style") || routerStore.getBreadcrumbNode("Material");
		    params.bCanCreateMultipleTestRuns = true;
		}
	});
});